<template>
  <div class="content">
    <!-- form thanh toan -->
    <form
      ref="paymentKuroneko"
      :action="envConfig.PAYMENT.KURONEKO.GATEPAY"
      method="post"
      accept-charset="SHIFT-JIS"
    >
      <input type="text" name="TRS_MAP" value="V_W02" />
      <input type="text" name="trader_code" :value="envConfig.PAYMENT.KURONEKO.trader_code" />
      <input type="text" name="order_no" :value="order.orderNo" />
      <input type="text" name="goods_name" :value="envConfig.PAYMENT.KURONEKO.goods_name" />
      <input type="text" name="settle_price" :value="10000" />
      <input
        type="text"
        name="buyer_name_kanji"
        :value="userInfo.last_name+whilespacejp+userInfo.first_name"
      />
      <input
        type="text"
        name="buyer_name_kana"
        :value="userInfo.last_name_kana+whilespacejp+userInfo.first_name_kana"
      />
      <input
        type="text"
        name="buyer_tel"
        :value="userInfo.phone_number_first + '-' + userInfo.phone_number_second + '-' + userInfo.phone_number_third"
      />
      <input type="text" name="buyer_email" :value="userInfo.email" />
      <input type="text" name="return_url" :value="envConfig.PAYMENT.KURONEKO.return_url" />
      <input type="text" name="success_url" :value="callBackUrls.success_url" />
      <input type="text" name="failure_url" :value="callBackUrls.failure_url" />
      <input type="text" name="cancel_url" :value="callBackUrls.cancel_url" />

      <button type="button" @click="onSubmit">Submit</button>
    </form>

    <p>ngng</p>
  </div>
</template>
<script>
import jpDate from "@/helpers/jpDate";
import api from "@/services/api";
import apiEndpoints from "@/services/apiEndpoints";
import { mapGetters } from "vuex";
import envConfig from "@/configs/env/config";
/* eslint-disable */
export default {
  // created() {
  //   this.order.orderNo = this.$route.params.orderNo;
  // },
  name: "A065",
  data() {
    return {
      whilespacejp: " ",
      dataAlert: {
        isShow: false,
        dismissText: "",
        confirmText: "",
        content: "",
        success: "",
        img: ""
      },
      isMobile: false,
      money_suffixes: "円",
      frontImage: "",
      behindImage: "",
      payMethod: "",
      userInfo: {
        first_name: "",
        last_name: "",
        first_name_kana: "",
        last_name_kana: "",
        phone_number_first: "",
        phone_number_second: "",
        phone_number_third: "",
        email: "",
        prefecture: "",
        city: "",
        street: "",
        zip_code: "",
        comment: ""
      },
      isModeShop: false,
      printInvoice: false,
      postCardImage: false,
      typePostcard: this.$t("front_end.a065.invoice_detail.postcard_normal"),
      textButtonConfirm: this.$t("front_end.a065.confirm"),
      isReOrder: false,
      isEditUserInfo: false,
      messageEditUser: this.$t("front_end.a065.confirm_edit_user_info"),
      btnYes: this.$t("front_end.a065.yes"),
      btnCancel: this.$t("front_end.a065.cancel"),
      isConfirmPayment: false,
      messageConfirmPayment: this.$t("front_end.a065.message_confirm_payment"),
      isConfirmPaymentShop: false,
      messageConfirmPaymentShop: this.$t(
        "front_end.a065.message_confirm_payment_shop"
      ),
      postcardID: null,
      isBringPostcard: false,
      postcardBring: 0,
      order: {
        date: "",
        orderNo: "",
        typeTemplate: null,
        category: "",
        numberReceiver: 0,
        numberPrint: 0,
        quantityPostcard: 0,
        feePrintBasic: 0,
        tax: 10,
        feeTaxBasic: 0,
        quantityScope: 0,
        feePrint: 0,
        feeTaxPrint: 0,
        pricePrint: 0,
        rowPrintOption: 4,
        stampQuantity: 0,
        feeStamp: 0,
        priceStamp: 0,
        pricePrintAddress: 0,
        feePrintAddress: 0,
        feeTotalOption: 0,
        feeTaxOption: 0,
        feeTotalNotDiscount: 0,
        discount: 0,
        feeDiscount: 0,
        feeAfterDiscount: 0,
        messageDiscount: "",
        namePostCard: "",
        pricePostcard: 0,
        feePostcard: 0,
        feeFinal: 0,
        templateName: "",
        typeDiscount: "",
        printType: 0
      },
      dataOrderInfo: {},
      // fake config
      configFake: {
        print_type: {
          print: 0,
          image: 1
        }
      },
      callBackUrls: {
        cancel_url: "",
        success_url: "",
        failure_url: ""
      },
      calculationInformation: {},
      dataEditAlert: {}
    };
  },
  components: {},
  computed: {
    ...mapGetters(["shopMode", "userData"])
  },
  async created() {
    this.jpDate = jpDate;
    this.envConfig = envConfig;
    this.isModeShop = !!this.shopMode?.shopName;
    //TODO remove khi tim ra du lieu
    this.createDummyData();
    this.onInit();

    this.createCallBackUrl();
  },
  mounted() {
    this.printInvoice =
      this.$store.state.userData.selected.printInvoice ?? this.printInvoice;
  },
  methods: {
    onSubmit() {
      // let form = this.$refs.paymentKuroneko;
      // let orgChar = document.charset;
      modChar(this.$refs.paymentKuroneko);
    },
    createCallBackUrl() {
      let cancel_url =
        "https://dev.photosmile.biz/complete-abnormal/" + this.order.orderNo;
      let success_url =
        "https://dev.photosmile.biz/complete-web/" + this.order.orderNo;
      let failure_url =
        "https://dev.photosmile.biz/complete-abnormal/" + this.order.orderNo;

      this.callBackUrls = {
        cancel_url,
        success_url,
        failure_url
      };
    },
    createDummyData() {
      this.frontImage =
        "https://i.pinimg.com/originals/ac/f0/4b/acf04b4cfb6650e571a778aafa62203a.jpg";
      this.behindImage =
        "https://i.pinimg.com/originals/ac/f0/4b/acf04b4cfb6650e571a778aafa62203a.jpg";
      this.order = {
        orderNo: "2020070901111176"
        // date: jpDate.toJpDate(new Date())
      };

      this.userInfo = {
        first_name: "a",
        last_name: "b",
        first_name_kana: "カナ",
        last_name_kana: "カナ",
        phone_number_first: "123",
        phone_number_second: "1224",
        phone_number_third: "1234",
        email: "emmail@gemail.com"
      };
    },
    createDummyData2(d) {
      d.option.stamp = {
        count: "50",
        price: 30,
        fee: 1500,
        tax: 150
      };

      return d;
    },

    onInit() {
      this.order.orderNo = this.userData?.order?.orderNo;

      let {
        ordererFirstName: first_name,
        ordererLastName: last_name,
        kanaFirstName: first_name_kana,
        kanaLastName: last_name_kana,
        mailAddress: email,
        phone1: phone_number_first,
        phone2: phone_number_second,
        phone3: phone_number_third,
        prefectures: prefecture,
        city,
        streetAddress1: street,
        companyName: company,
        departmentName: department,
        comment,
        postalCode,
        streetAddress2: building
      } = this.userData.order?.ordererInformation;

      let zipCodeFirst = null;
      let zipCodeLast = null;
      if (postalCode) {
        zipCodeFirst = postalCode.substr(0, 3);
        zipCodeLast = postalCode.substr(3);
      }
      this.userInfo = {
        first_name,
        last_name,
        first_name_kana,
        last_name_kana,
        phone_number_first,
        phone_number_second,
        phone_number_third,
        email,
        prefecture,
        city,
        street,
        company,
        department,
        comment,
        building,
        zipCodeFirst,
        zipCodeLast
      };
    },
    async getImageBackFromOrderNoHashed(orderNo) {
      //CR :1pfwb8sZ
      // this.ordererInformation.orderNo = "020081301000125";
      let respPG = await api.post(apiEndpoints.productGenerate, {
        orderno: orderNo
      });

      if (respPG && respPG.data?.code && Number(respPG.data.code) === 200) {
        let respEdu = await api.post(apiEndpoints.editDataUploadUrl, {
          orderNo: orderNo,
          filename: "preview-image-" + orderNo,
          accessType: "preview"
        });

        // console.log("respEdu", respEdu);
        if (respEdu && respEdu.data?.url) {
          return respEdu.data.url;
        }
      }
      return "";
    },
    onClickEditOderer() {
      this.$refs.modalConfirmEdit.show();
      this.$store.commit("userData/SET_SELECTED", {
        printInvoice: this.printInvoice
      });
    },
    onModalConfirmEditYes() {
      this.$refs.modalConfirmEdit.hide();
      this.$router.push({ name: "a070" });
    },
    onModalConfirmEditCancel() {
      this.$refs.modalConfirmEdit.hide();
    },

    async getPriceInfomation() {
      let { orderNo } = this.order;
      let { data } = await api.post(apiEndpoints.getPriceInformation, {
        orderNo
      });
      if (data && data.calculationInformation) {
        //TODO remove dummy 2
        // data.calculationInformation = this.createDummyData2(
        //   data.calculationInformation
        // );

        //end dummpy

        // pre calculation

        // let debug = 1;
        //if (!debug) {
        this.calculationInformation = this.preCalculate(
          data.calculationInformation
        );
        //} else {
        // this.calculationInformation = this.preCalculate({
        //   information: { tax: 10 },
        //   order: {
        //     orderNo: "2020081701000167",
        //     orderDate: "2020/08/17",
        //     typeNo: "MO-02",
        //     type: "喪中",
        //     photoOrPrint: "print",
        //     isReorder: false
        //   },
        //   basicPrice: { fee: 2300, tax: 230 },
        //   option: {
        //     addressname: { count: 1, price: 30, fee: 30, tax: 3 },
        //     tax: 3
        //   },
        //   discount: {
        //     discount: {
        //       discountMethod: "金額",
        //       discountContent: 55,
        //       discountName: "73",
        //       discount: 55
        //     }
        //   },
        //   postcard: { name: "私製喪中ハガキ", count: 0, price: 0, fee: 0 }
        // });
        //}
      }
    },

    preCalculate(calcInfo) {
      let {
        order = {},
        basicPrice = {},
        printPrice = {},
        option = {},
        discount = {},
        postcard = {}
      } = {
        ...calcInfo
      };

      option.totalFee = 0;
      // console.log("calcInfo", calcInfo);
      if (option?.addressname?.fee) {
        option.totalFee += Number(option.addressname.fee);
      }

      if (option.stamp?.fee) {
        option.totalFee += Number(option.stamp.fee);
      }

      discount.sumDiscount = 0;

      if (discount.discount?.discount) {
        discount.sumDiscount += Number(discount.discount.discount);
      }
      if (discount.coupon?.discount) {
        discount.sumDiscount += Number(discount.coupon.discount);
      }

      let finalFee = 0;

      if (basicPrice) {
        if (basicPrice.fee) {
          finalFee += Number(basicPrice.fee);
        }

        if (basicPrice.tax) {
          finalFee += Number(basicPrice.tax);
        }
      }

      if (printPrice) {
        if (printPrice.fee) {
          finalFee += Number(printPrice.fee);
        }
        if (printPrice.tax) {
          finalFee += Number(printPrice.tax);
        }
      }

      //stamp + address

      if (option.stamp?.fee) {
        finalFee += Number(option.stamp.fee);

        if (option.stamp?.tax) {
          finalFee += Number(option.stamp.tax);
        }
      }

      if (option.addressname?.fee) {
        finalFee += Number(option.addressname.fee);
        if (option.addressname.tax) {
          finalFee += Number(option.addressname.tax);
        }
      }

      if (discount.discount?.discount) {
        finalFee -= Number(discount.discount.discount);
      }
      if (discount.coupon?.discount) {
        finalFee -= Number(discount.coupon.discount);
      }
      if (postcard?.fee) {
        finalFee += Number(postcard.fee);
      }

      return {
        finalFee,
        order,
        basicPrice,
        printPrice,
        option,
        discount,
        postcard
      };
    },
    showDialogConfirmOrder() {
      this.$refs.modalConfirm.show();
    },
    onModalConfirmCancel() {
      this.$refs.modalConfirm.hide();
    },
    async onModalConfirmYes() {
      if (this.isModeShop) {
        this.$refs.modalConfirm.hide();
        //TODO call api update
        let orderNo = this.calculationInformation.order?.orderNo;
        let settlePrice = "" + this.calculationInformation.finalFee;
        let settleDate = this.$moment().format("YYYY/MM/DD");
        let body = {
          orderNo,
          printOrder: this.printInvoice ? `PRINT` : `NOPRINT`,
          settlePrice,
          settleDate
        };
        let respConfirm = await api.post(apiEndpoints.storePayment, body);

        //200 ok
        if (respConfirm) {
          // console.log("respConfirm", respConfirm);
          this.$router.push({
            name: "a085",
            params: { orderNo: this.order.orderNo }
          });
        }
      } else {
        //kuroneko
        // console.log("submit paymentKuroneko");
        this.$refs.paymentKuroneko.submit();
      }
      this.callUpdatePrintOrder();
    },
    callUpdatePrintOrder() {
      let orderNo = this.calculationInformation.order?.orderNo;
      // PRINT | NOPRINT
      api.post(apiEndpoints.updatePrintOrder, {
        orderNo,
        printOrder: this.printInvoice ? `PRINT` : `NOPRINT`
      });
    }
  }
};
</script>

<style scoped>
input {
  display: block;
}
</style>
